<template>
  <Head title="Reset Password" />
  <div class="flex items-center justify-center p-6 min-h-screen bg-blue-800">
    <div class="w-full max-w-md">
      <flash-messages />
      <img :src="app.logo_w" :alt="`${app.name} logo`" height="50" />
      <form class="mt-8 bg-white shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-12">
          <h1 class="text-center text-3xl font-bold">Reset password</h1>
          <div class="mt-6 mx-auto w-24 border-b-2" />
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Email" type="email" autofocus autocapitalize="off" />
        </div>
        <div class="flex justify-center items-center px-10 py-4 bg-gray-100 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-blue ml-auto" type="submit">Send Password Reset Link</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    Head,
    LoadingButton,
    TextInput,
    FlashMessages,
  },
  props: {
    app: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        email   : '',
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/forget-password')
    },
  },
}
</script>
